import { useState } from "react";
import { useForm } from "react-hook-form";

import { Container, Content, Form, Loading } from "./styles";

import Logo from "../../../assets/images/branding/logo-primary.svg";

import WhatsAppIcon from "../../../assets/images/icons/whatsapp.svg";
import EmailIcon from "../../../assets/images/icons/email.svg";
import LocationIcon from "../../../assets/images/icons/location.svg";
import CareersIcon from "../../../assets/images/icons/careers.svg";

const Footer = () => {
  const year = new Date().getFullYear();
  const { register, handleSubmit, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [information, setInformation] = useState("");

  const onSubmit = (data) => {
    setLoading(true);

    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute("6LeFboQrAAAAAMTfaqIcZp5tpsVEgzwkzXVVISE1", {
          action: "submit",
        })
        .then(async function (token) {
          try {
            const response = await fetch(
              "https://esoccerprogram.com/api/formulario.php",
              {
                method: "POST",
                body: JSON.stringify({
                  ...data,
                  recaptcha: token,
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            const dataResponse = await response.json();

            setInformation(dataResponse.message);
          } catch (error) {
            setInformation(error.message);
          } finally {
            setTimeout(() => {
              setLoading(false);
              setInformation("");
            }, 3000);
            reset();
          }
        });
    });
  };

  return (
    <Container id="form">
      <Content>
        <div>
          <img src={Logo} alt="imagem" />

          <nav>
            <ul>
              <li>
                <a
                  href="https://wa.me/5511942909674"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={WhatsAppIcon} alt="imagem" />
                  (11) 94290-9674
                </a>
              </li>
              <li>
                <img src={EmailIcon} alt="imagem" />
                pamela@esoccerprogram.com
              </li>
              <li>
                <img src={LocationIcon} alt="imagem" />
                Arena Ibirapuera Av. Dr. Dante Pazzanese, 421 Vila Mariana
              </li>
              <li>
                <img src={CareersIcon} alt="imagem" />
                Trabalhe conosco Envie seu currículo para: vagas@esoccerprogram.com
              </li>
            </ul>
          </nav>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading && (
            <Loading>
              {information !== "" ? <span>{information}</span> : <div></div>}
            </Loading>
          )}

          <label htmlFor="name">Nome</label>
          <input {...register("name")} required id="name" />

          <label htmlFor="email">Email</label>
          <input {...register("email")} required type="email" id="email" />

          <label htmlFor="phone">Telefone</label>
          <input {...register("phone")} required id="phone" />

          <div>
            <label>Motivo do contato</label>

            <div>
              <div>
                <input
                  type="radio"
                  required
                  {...register("reasonForContact")}
                  value="Sou representante de escola"
                />
                <span>Sou representante de escola</span>
              </div>
              <div>
                <input
                  type="radio"
                  required
                  value="Quero matricular meu filho"
                  {...register("reasonForContact")}
                />
                <span>Quero matricular meu filho</span>
              </div>
            </div>
          </div>

          <label htmlFor="message">Mensagem</label>
          <textarea {...register("message")} required id="message" />

          <button type="submit">CONFIRMAR</button>
        </Form>
      </Content>

      <footer>
        © {year} ESP | Todos os direitos reservados - Desenvolvido por{" "}
        <strong>YPB MKT DIGITAL</strong>
      </footer>
    </Container>
  );
};

export default Footer;
